import Component from './tag.vue';
export default Component;
